var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"help-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.descripcion)?_c('p',{staticClass:"help-description"},[_vm._v(_vm._s(_vm.descripcion))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }